import React, { useState, useMemo } from "react";
import DashboardBox from "../components/DashboardBox";
import Table from "../components/Table";
import { DatePicker, message } from "antd";
import dayjs from "dayjs";
import { useFetchDashboardStatus,useFetchChangeJob,useFetchSendCaseToEmployee } from "../hooks/useFetch";
import { useFetchUser } from "../../../../modules/admin/Employees/hooks/useFetch";

const { RangePicker } = DatePicker;

const DashboardPage = () => {
  const today = dayjs();
  const [dateRange, setDateRange] = useState([today, today]);
  const companyId = sessionStorage.getItem('activeCompanyId');
  const { mutateAsync: changeJob } = useFetchChangeJob();
  const { mutateAsync: sendCaseToEmployee } = useFetchSendCaseToEmployee();
  // format dateRange for API (YYYY-MM-DD)
  const formattedRange =
    dateRange && dateRange.length === 2
      ? {
          start: dateRange[0].format("YYYY-MM-DD"),
          end: dateRange[1].format("YYYY-MM-DD"),
        }
      : { start: today.format("YYYY-MM-DD"), end: today.format("YYYY-MM-DD") };

  const {
    data: dashboardStatus,
    isLoading,
    isError,
    refetch,
  } = useFetchDashboardStatus(formattedRange.start, formattedRange.end);

  // Fetch admin list for export dropdown
  const { data: adminListData, isLoading: isLoadingAdmins } = useFetchUser(companyId);

  // Prepare admin list for dropdown (filter only employees/admins, not all users)
  const adminList = useMemo(() => {
    if (!adminListData) return [];
    // Use adminListData directly or filter as needed
    // Assuming adminListData contains users with UserName field
    return adminListData.map(admin => ({
      id: admin.id,
      UserName: admin.UserName,
      name: admin.UserName,
      admin: admin.UserName,
    }));
  }, [adminListData]);

  const handleShiftClick = () => {
    message.info("Shift button clicked");
    // Add your shift logic here
  };

  const handleRoleChange = async (scheduleId, roleType, checked) => {
    try {
      const payload = {
        id: scheduleId,
        job: roleType,
        checked: checked
      }
      const saved = await changeJob(payload)
      // คืนค่าที่บันทึกจริงให้ตารางเอาไปแสดง — กันจอกับ DB ไม่ตรงกัน
      return saved?.additionalTaskTypes ?? undefined
      // ไม่ต้อง refetch ทั้ง dashboard หลังกดสวิตช์ — toggle เปลี่ยนแค่ taskType
      // ของคนเดียว ไม่กระทบ count/ค่าเฉลี่ย และ optimistic update อัปเดตจอให้แล้ว
    } catch (error) {
      console.log("Validation or API error:", error);
      // เซฟพลาด: ดึงค่าจริงกลับมา sync (optimistic จะถูก reset ให้ตรง server)
      refetch()
      return undefined
    }
  };

  const handleExport = async (exportData) => {
    try {
      const payload = {
        quantity: exportData.quantity,
        sendToUserId: exportData.adminId,
        type: exportData.type,
        sendFromUserId: exportData.record.userId,
      }
      console.log(payload);
      await sendCaseToEmployee(payload);
      setTimeout(() => {
        refetch();
      }, 500);
    } catch (error) {
      console.log("Validation or API error:", error);
    }
  };

  return (
    <div style={{ padding: 16, background: "#f5f5f5", minHeight: "100vh" }}>
      <div style={{ display: "flex", gap: 8, marginBottom: 20 }}>
       {(() => {
         const currentHour = new Date().getHours();
         const isDay = currentHour >= 8 && currentHour < 20;
         const shiftLabel = isDay ? "Day" : "Night";
         const shiftColor = isDay ? "#3498db" : "#34495e";
         return (
           <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
             <h1 style={{
               margin: 0,
               fontSize: '2rem',
               fontWeight: 'bold',
               color: '#212121',
               letterSpacing: '0.5px',
               lineHeight: 1.2
             }}>
               Dashboard Monitoring
             </h1>
             <span style={{
               fontSize: '1.2rem',
               background: shiftColor,
               color: '#fff',
               padding: '4px 20px',
               borderRadius: 20,
               fontWeight: 500,
               letterSpacing: '1.5px'
             }}>
               {shiftLabel}
             </span>
           </div>
         );
       })()}
      </div>
      <div
        style={{
          display: "flex",
          gap: 12,
          background: "#e0e0e0",
          borderRadius: 10,
          padding: 8,
          justifyContent: "space-between",
          marginBottom: 20,
        }}
      >
        {dashboardStatus?.data?.map((box) => (
          <DashboardBox key={box.status} {...box} />
        ))}
      </div>
      <Table 
        data={dashboardStatus?.userSchedules} 
        loading={isLoading}
        onShiftClick={handleShiftClick}
        onRoleChange={handleRoleChange}
        onExport={handleExport}
        adminList={adminList}
      />
    </div>
  );
};

export default DashboardPage;
